<template>
  <teleport v-if="widget" :to="'#' + dest">
    <div
      class="orm-carcategoryslider"
      :class="!disablecontainer ? 'orm-container orm-py-56' : ''"
    >
      <div class="orm-row orm-mb-32" v-if="!disablecontainer">
        <div class="orm-col-xs-12 text-center">
          <h2
            class="orm-headline__h1"
            v-html="
              i18n('modules/cars/title') ||
                'Diese Top-Fahrzeuge warten auf dich!'
            "
          ></h2>
        </div>
      </div>
      <div class="orm-row center-xs center-md" v-if="vehicles?.length > 0">
        <TopCar v-for="car in vehicles" :key="car.id" :data="car" />
      </div>
      <div v-else>
        <div
          class="orm-preload-page orm-preload-page-static"
          v-if="!disablecontainer"
        >
          <i class="fa fa-spinner-third orm-rotate360"></i>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent, toRef } from "vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import TopCar from "@/components/cargroup/TopCar.vue";

export default defineComponent({
  name: "AboV2TopVehicles",
  components: { TopCar },
  mixins: [i18n, stripHTML],
  setup(props) {
    const dest = toRef(props, "teleport").value;
    let widget = false;
    const myEle = document.getElementById(dest);
    if (myEle !== null) {
      widget = true;
    }

    return {
      widget,
      dest,
      // offers,
    };
  },
  data() {
    return {
      vehicles: null,
      offers: null,
      demo: process.env.VUE_APP_DEMO,
      carcategory: [],
      sttype: "Auto-Abo",
      disablecontainer: false,
      filtercategory: null,
    };
  },
  props: {
    teleport: {
      type: String,
      default: "crentAboTopVehicles",
    },
  },
  async created() {
    const teleportWrapper = document.getElementById(this.teleport);
    if (teleportWrapper == null) {
      return;
    }

    const vehicles = await store.dispatch("cargroup/GET_VEHICLES_V2", {
      top: true,
    });

    this.vehicles = JSON.parse(JSON.stringify(vehicles.vehicles));
    this.vehicle = this.vehicles[0];

    if (!this.vehicle)
      this.disablecontainer = true;
  },
  methods: {
    openContact(car) {
      console.log("not implemented");
    },
  },
});
</script>
